export default {
	"Order.NoProductsSelected": "No products selected",
	"Order.prompt": "prompt",
	"Order.UntieTheBindingForTheTimeBeing": "Untie the binding for the time being",
	"Order.UnbindTheAccount": "Unbind the account",
	"Order.SorryFailedToCreateOrder": "Sorry, failed to create order!",
	"Order.RepeatPurchasePrompts": "Repeat purchase prompts",
	"Order.ignore": "ignore",
	"Order.ViewOrders": "View orders",
	"Order.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "WeChat can enter the access after authorization, request authorization...",
	"Order.GotIt": "Got it",
	"Order.PleaseRedeemItInWeChatOrCallAPP": "Please redeem it in WeChat or [Call] APP",
	"Order.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "To pay for this order, please pay in the order logistics of the [Call] public account"
}